import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './FormGroup.module.less';
function FormGroup(props) {
    const { className, children, ...rest } = props;
    return (_jsx("div", { className: cls(styles.formGroup, className), ...rest, children: children }));
}
export default memo(FormGroup);
